export default theme => ({
  names: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 5
  },
  name: {
    width: 'calc((100% - 10px) / 2)'
  },
  signIn: {
    fontSize: 10,
    color: theme.grey2
  },
  signupContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 18
  },
  logoWrapper: {
    '& > div': {
      justifyContent: 'flex-start'
    }
  }
});
